/* LCDF owned-adapter consent containment. No cookies, consent writes or event replay. */
(function (global) {
  'use strict';
  if (global.EMALcdfConsent) return;
  var SETTING = '3vON4N-3KVaeQM';
  var SERVICES = {
    analytics: { id: 'HkocEodjb7', name: 'Google Analytics' },
    ads: { id: 'S1_9Vsuj-Q', name: 'Google Ads' },
    klaviyo: { id: 'm5uB6gnoW', name: 'Klaviyo' }
  };
  var states = {}, layerStates = {}, epoch = 0, revision = 0, sdkResolved = false;
  var ready = false, initialAction = false, waiting = [], observedLayer, scanned = 0, latest;
  function own(object, key) { return !!object && Object.prototype.hasOwnProperty.call(object, key); }
  function object(value) { return !!value && typeof value === 'object' && !Array.isArray(value); }
  function signature(value) { return ['analytics', 'ads', 'klaviyo'].map(function (key) { return value[key] === true ? '1' : '0'; }).join(''); }
  function setStates(next, layer) {
    if (signature(next) !== signature(layer ? layerStates : states)) revision++;
    if (layer) layerStates = next; else states = next;
  }
  function read(details) {
    var next = {}, consent = details && details.consent, services = details && details.services;
    var valid = object(details) && own(details, 'consent') && own(details, 'services') &&
      object(consent) && own(consent, 'type') && consent.type === 'EXPLICIT' &&
      own(consent, 'setting') && object(consent.setting) && own(consent.setting, 'id') && consent.setting.id === SETTING && object(services);
    Object.keys(SERVICES).forEach(function (key) {
      var expected = SERVICES[key], service = valid && own(services, expected.id) && services[expected.id];
      next[key] = !!(object(service) && own(service, 'name') && service.name === expected.name &&
        own(service, 'consent') && object(service.consent) && own(service.consent, 'given') && service.consent.given === true &&
        own(service.consent, 'type') && service.consent.type === 'EXPLICIT');
    });
    return next;
  }
  function readRow(row) {
    var valid = object(row) && own(row, 'event') && own(row, 'type') && (row.type === 'EXPLICIT' || row.type === 'explicit'), next = {};
    Object.keys(SERVICES).forEach(function (key) { var name = SERVICES[key].name; next[key] = !!(valid && own(row, name) && row[name] === true); });
    return next;
  }
  function finishReady() {
    if (ready || !sdkResolved || !latest) return;
    ready = true;
    var callbacks = waiting; waiting = [];
    callbacks.forEach(function (callback) { try { callback({ fromUserAction: initialAction }); } catch (_) {} });
  }
  function scanLayer() {
    var rows = global.dataLayer;
    if (!Array.isArray(rows)) { setStates({}, true); latest = null; return; }
    if (rows !== observedLayer || rows.length < scanned) {
      observedLayer = rows; scanned = 0; latest = null; setStates({}, true);
    }
    // Process every intervening consent row: deny -> grant must invalidate a
    // pending action even if SDK callbacks lag or another wrapper replaces ours.
    for (; scanned < rows.length; scanned++) {
      var row = rows[scanned];
      if (row && row.event === 'consent_status') {
        latest = row; setStates(readRow(row), true);
      }
    }
    if (latest) setStates(readRow(latest), true); // Also fail closed on in-place malformed updates.
    finishReady();
  }
  function accept(details, fromAction) {
    setStates(read(details), false); sdkResolved = true;
    if (!ready) initialAction = fromAction === true;
    scanLayer();
  }
  function refresh() {
    if (sdkResolved) return; // Late initialization cannot replace an established consent event.
    var current = ++epoch;
    try {
      if (!global.__ucCmp || typeof global.__ucCmp.getConsentDetails !== 'function') return;
      Promise.resolve(global.__ucCmp.getConsentDetails()).then(function (details) {
        if (current === epoch) accept(details, false);
      }, function () { if (current === epoch) accept(null, false); });
    } catch (_) { if (current === epoch) accept(null, false); }
  }
  global.EMALcdfConsent = Object.freeze({
    allows: function (key) { scanLayer(); return own(SERVICES, key) && states[key] === true && layerStates[key] === true; },
    revision: function () { scanLayer(); return revision; },
    whenReady: function (callback) {
      if (typeof callback !== 'function') return;
      scanLayer();
      if (ready) callback({ fromUserAction: initialAction }); else waiting.push(callback);
    }
  });
  // Preserve the original queue operation and return value; never add/replay an
  // event. This only lets delayed initial consent rows complete readiness.
  global.dataLayer = global.dataLayer || [];
  if (Array.isArray(global.dataLayer)) {
    var originalPush = global.dataLayer.push;
    global.dataLayer.push = function () { var result = originalPush.apply(this, arguments); scanLayer(); return result; };
  }
  global.addEventListener('UC_CONSENT', function (event) {
    ++epoch; // Invalidate in-flight reads even when the new event is malformed.
    if (!sdkResolved || !event || !object(event.detail) || (event.detail.consent && event.detail.consent.fromUserAction === true)) revision++;
    accept(event && event.detail, !!(event && event.detail && event.detail.consent && event.detail.consent.fromUserAction));
  });
  global.addEventListener('UC_UI_INITIALIZED', refresh);
  scanLayer(); refresh();
})(window);
